import axios from 'axios'
import FileSaver from 'file-saver'
import qs from 'qs'
import fn from '../../utils/functions'
import dayjs from 'dayjs';

// Normaliza fechas en profundidad para evitar que qs.stringify destruya objetos Dayjs
export function convertDates(obj) {
  if (obj == null) return obj;

  // Detecta Day.js correctamente
  if (dayjs.isDayjs(obj)) {
    return obj.toISOString();
  }

  // Detecta Date nativo
  if (obj instanceof Date) {
    return obj.toISOString();
  }

  // Arrays → recorrer
  if (Array.isArray(obj)) {
    return obj.map(item => convertDates(item));
  }

  // Objetos → recorrer recursivamente
  if (typeof obj === 'object') {
    const newObj = {};
    for (const key in obj) {
      newObj[key] = convertDates(obj[key]);
    }
    return newObj;
  }

  
  return obj;
}

function initSession () {
  const session = {
    // Usuarios
    users: {
      tableData: [],
      totalUsers: 0
    },
    queryUsers: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      creationDateTimeFrom: '',
      creationDateTimeTo: '',
      serviceAccount: ''
    },
    listSelectedFiltersUsers: [],

    newUserSession: {
      username: null,
      email: null,
      name: null,
      firstSurname: null,
      secondSurname: null,
      taxIdentificationNumber: null,
      partyTaxIdentificationNumber: null,
      userentities: [],
      rolesAuthoritiesUser: {
        roles: [],
        authorities: [],
        projectId: null
      }
    },

    modifyUserSession: {
      username: null,
      email: null,
      partyTaxIdentificationNumber: null,
      usuario: {},
      userentities: [],
      rolesAuthoritiesUser: {
        roles: [],
        authorities: [],
        projectId: null
      }
    },
    // Datos Select Filtros Usuarios
    optionsFilterUsersUsername: [],
    optionsFilterUsersCompleteName: [],
    optionsFilterUsersCreationDateTime: [],
    optionsFilterUsersTrial: [],
    optionsFilterUsersEnable: [],
    optionsFilterUsersServiceAccount: [],
    optionsFilterUsersLastConnectionDate: [],
    optionsFilterUsersIdNumber: [],
    optionsFilterUsersParty: [],
    optionsFilterUsersPartyType: [],
    optionsFilterUsersIsPartySponsor: [],
    optionsFilterUsersEmail: [],

  }
  return session
}
function initLocal () {
  const local = {

    // Columnas Tabla Usuarios
    isShowUsuario: true,
    isShowCompleteName: true,
    isShowFechaAlta: true,
    isShowNumeroIntentos: true,
    isShowActivo: true,
    isShowEmail: true,
    isShowFechaUltimaConexion: true,
    isShowNumeroIdentificacion: true,
    isShowServiceAccount: true,
    isShowPasswordExpirationDate: false
  }
  return local
}
function setByUserLocalUser () {
  const local = {

    // Columnas Tabla Usuarios
    isShowUsuario: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).usuarios.isShowUsuario,
    isShowCompleteName: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).usuarios.isShowCompleteName,
    isShowFechaAlta: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).usuarios.isShowFechaAlta,
    isShowNumeroIntentos: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).usuarios.isShowNumeroIntentos,
    isShowActivo: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).usuarios.isShowActivo,
    isShowEmail: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).usuarios.isShowEmail,
    isShowFechaUltimaConexion: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).usuarios.isShowFechaUltimaConexion,
    isShowPasswordExpirationDate: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).usuarios.isShowPasswordExpirationDate,
    isShowNumeroIdentificacion: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).usuarios.isShowNumeroIdentificacion,
    isShowServiceAccount: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).usuarios.isShowServiceAccount
  }
  return local
}

// state
const state = {
  userConfigLocalStorage: '',
  local: {

    // Columnas Tabla Usuarios
    isShowUsuario: true,
    isShowCompleteName: true,
    isShowFechaAlta: true,
    isShowNumeroIntentos: true,
    isShowActivo: true,
    isShowEmail: true,
    isShowFechaUltimaConexion: true,
    isShowNumeroIdentificacion: true,
    isShowServiceAccount: true,
    isShowPasswordExpirationDate: false
  },
  session: initSession()
}

// getters
const getters = {
  // Datos Tabla Usuarios
  users: state => {
    return state.session.users
  },
  queryUsers: state => {
    return state.session.queryUsers
  },
  listSelectedFiltersUsers: state => {
    return state.session.listSelectedFiltersUsers
  },
  // Objeto Creación usuario en sesión
  newUserSession: state => {
    return state.session.newUserSession
  },
  modifyUserSession: state => {
    return state.session.modifyUserSession
  },

  // Datos Select Filtros Usuarios
  optionsFilterUsersUsername: state => {
    return state.session.optionsFilterUsersUsername
  },
  optionsFilterUsersCompleteName: state => {
    return state.session.optionsFilterUsersCompleteName
  },
  optionsFilterUsersCreationDateTime: state => {
    return state.session.optionsFilterUsersCreationDateTime
  },
  optionsFilterUsersTrial: state => {
    return state.session.optionsFilterUsersTrial
  },
  optionsFilterUsersEnable: state => {
    return state.session.optionsFilterUsersEnable
  },
  optionsFilterUsersServiceAccount: state => {
    return state.session.optionsFilterUsersServiceAccount
  },
  optionsFilterUsersLastConnectionDate: state => {
    return state.session.optionsFilterUsersLastConnectionDate
  },
  optionsFilterUsersIdNumber: state => {
    return state.session.optionsFilterUsersIdNumber
  },
  optionsFilterUsersParty: state => {
    return state.session.optionsFilterUsersParty
  },
  optionsFilterUsersPartyType: state => {
    return state.session.optionsFilterUsersPartyType
  },
  optionsFilterUsersIsPartySponsor: state => {
    return state.session.optionsFilterUsersIsPartySponsor
  },
  optionsFilterUsersEmail: state => {
    return state.session.optionsFilterUsersEmail
  },

  // Columnas Tabla Usuarios
  isShowUsuario: state => {
    return state.local.isShowUsuario
  },
  isShowCompleteName: state => {
    return state.local.isShowCompleteName
  },
  isShowFechaAlta: state => {
    return state.local.isShowFechaAlta
  },
  isShowNumeroIntentos: state => {
    return state.local.isShowNumeroIntentos
  },
  isShowActivo: state => {
    return state.local.isShowActivo
  },
  isShowEmail: state => {
    return state.local.isShowEmail
  },
  isShowFechaUltimaConexion: state => {
    return state.local.isShowFechaUltimaConexion
  },
  isShowPasswordExpirationDate: state => {
    return state.local.isShowPasswordExpirationDate
  },
  isShowNumeroIdentificacion: state => {
    return state.local.isShowNumeroIdentificacion
  },
  isShowServiceAccount: state => {
    return state.local.isShowServiceAccount
  }
}

// actions
const actions = {
  // Crear key Usuario
  setUserNameUser ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalUser()
    }
  },
  async isNewVersionUsuariosLocalState ({ state }, localStorage) {
    const isnew =  fn.isNewVersion(state, localStorage.usuarios)
    return isnew
  },

  /* USUARIOS */
  /**
  * Servicio para traer los usuarios del sistema.
  * Se utiliza también para ordenar la tabla, la paginación,
  * el tamaño de la tabla y los filtros.
  */
  async getUsers ({
    commit, rootState
  }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/user',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      // Transformar fechas a tipo Date para cada usuario
      const tableData = response.data.content.map(user => ({
        ...user,
        creationDateTime: user.creationDateTime ? new Date(user.creationDateTime) : null,
        lastConnection: user.lastConnection ? new Date(user.lastConnection) : null
      }))
      commit('USERS_STATE', {
        tableData,
        totalUsers: response.data.totalElements
      })

      return response
    } catch (error) {
      console.log('getUsers: ', error.response)
      throw error.response
    }
  },

  /*
  * Servicio para exportar todos los usuarios bajo parámetros en formato CSV
  */
  async handleDownloadAllCsvUsers ({
    commit, rootState
  }, params) {
    try {
      params.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        params.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/user/csv',
        params: params,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        headers: { 'Accept-Language': params.activeLang },
        responseType: 'blob',
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false })
        }
      })
      console.log('RESPONSE handleDownloadAllCsvUsers:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })

      const filename = fn.extractFilename(response.headers['content-disposition'], 'all-csv-users.pdf')
      FileSaver.saveAs(blob, filename)
      return (filename)
    } catch (error) {
      console.log('handleDownloadAllCsvUsers: ', error.response)
      throw error.response
    }
  },

  /*
  * Servicio para cambiar el estado de un usuario
  */
  async setStatusUser ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/user/' + data.id + '/status',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return (response)
    } catch (error) {
      console.log('setStatusUser: ', error)
      throw error.response
    }
  },

  /*
  * Servicio para cambiar el flag de service account de un usuario
  */
  async setServiceAccountUser ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/user/' + data.id + '/service-account',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return (response)
    } catch (error) {
      console.log('setServiceAccountUser: ', error)
      throw error.response
    }
  },

  /**
   * Establecer el estado de reset OTP de un usuario.
   *
   * @param {Object} data - ID del usuario y nuevo estado de reset OTP
   */
  async setResetOTPUser ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/user/' + data.id + '/reset-otp',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return (response)
    } catch (error) {
      console.log('setResetOTPUser: ', error)
      throw error.response
    }
  },

  /**
   * Servicio para resetear la contraseña de varios usuarios
   * @param {*} data
   */
  async resetPasswordMassive ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/user/password',
        params: data.query,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false })
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return (response)
    } catch (error) {
      console.log('resetPasswordMassive: ', error)
      throw error.response
    }
  },

  /**
   * Servicio para la carga masiva de usuarios
   * @param {*} data
   */
  async massiveUserUpload ({
    commit, rootState
  }, data) {
    console.log(data)
    const formData = new FormData()
    formData.append('file', data.file.raw)
    formData.append('projectId', data.service)
    try {
      const response = await axios({
        method: 'POST',
        url: '/user/fromfile',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData
      })
      const jwt = response.headers.authorization
      if (jwt !== rootState.session.jwt) {
        axios.defaults.headers.common.Authorization = jwt
        commit('JWT_STATE', jwt)
      }
      return (response)
    } catch (error) {
      console.log('massiveUserUpload: ', error)
      throw error.response
    }
  },

  /* DETALLE USUARIO */
  // INFO
  /**
   * Servicio para traer detalle de un usuario
   * @param {*} userId
   */
  async getUserDetail ({
    commit, rootState
  }, userId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/user/' + userId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener datos de contacto de un usuario
   * @param {*} userId
   */
  async getUserMedia ({
    commit, rootState
  }, userId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/user/' + userId + '/media',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener los proyectos asociados al usuario
   * @param {*} userId
   */
  async getUserProjects ({
    commit, rootState
  }, userId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/user/' + userId + '/media/projects'
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener todos los permisos
   */
  async getAllAuthorities ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/user/' + data.userId + '/media/authorities',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para dar de alta un nuevo perfil
   */
  async addUsersRole ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/user/' + data.userId + '/media/new/perfil',
        data: data.query,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Saber si el usuario es administrador o no
   * @param {*} userId
   */
  async isUserAdmin ({
    commit, rootState
  }, userId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/user/' + userId + '/media/admin'
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
   * Saber si el usuario es sponsor o no
   * @param {*} params
   */
  async getUserSponsor ({
    commit, rootState
  }, projectId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/user/' + projectId + '/isusersponsor',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para añadir datos de contacto de un usuario
   * @param {*} data
   */
  async addUserMedia ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/user/' + data.userId + '/media',
        params: data.query,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para eliminar datos de contacto de un usuario
   * @param {*} data
   */
  async deleteUserMedia ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'DELETE',
        url: '/user/' + data.userId + '/media/' + data.userMediaId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para actualizar datos de contacto (de tipo email) de un usuario
   * @param {*} data
   */
  async updateUserMediaEmail ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/user/' + data.userId + '/media/' + data.userMediaId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener los tipos de contacto registrados
   */
  async getOptionsMediaType ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/mediatype',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener entidades de un usuario
   * @param {*} userId
   */
  async getUserEntities ({
    commit, rootState
  }, params) {
    try {
      params.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        params.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/user/' + params.userId + '/entity',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: params
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener empresas habilitadas dado un servicio de un usuario
   * @param {*} data
   */
  async getPartiesByProject ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/me/project/' + data.projectId + '/party',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data.content
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener centros asociados a una empresa dado un servicio de un usuario
   * @param {*} data
   */
  async getCentresByParty ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/me/project/' + data.projectId + '/party/' + data.partyId + '/centre'
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Servicio anterior que apunta a fenix-backend
  async getCentresByPartyFenixBackend ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/me/project/' + data.projectId + '/party/' + data.partyId + '/centre',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para eliminar entidades de un usuario
   * @param {*} data
   */
  async addUserEntity ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/user/' + data.userId + '/entity',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: data.query
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para eliminar entidades de un usuario
   * @param {*} data
   */
  async deleteUserEntity ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/user/' + data.userId + '/entity/' + data.entityId
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener la lista de perfiles y permisos de un usuario
   * @param {*} data
   */
  async getUserRolesAuthorities ({
    commit, rootState
  }, data) {
    try {
      // Swagger valora null como espacio en blanco. Por lo tanto, transformamos el valor si el id de proyecto es null
      if (data.query.projectId === null || data.query.projectId === 'all') {
        data.query.projectId = -1  // -1 es el valor que luego asignamos a null en el backend
      }
      console.log('data.query', data.query)
      const response = await axios({
        method: 'GET',
        url: '/user/' + data.userId + '/roleauthority',
       baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

   /**
   * Servicio para obtener la lista de roles de un usuario
   * @param {*} data
   */
    async getUserRoles ({
      commit, rootState
    }, data) {
      try {
        const response = await axios({
          method: 'GET',
          url: '/user/' + data.userId + '/roleauthority/allUserRoles',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          params: data.query
        })

        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return response.data
      } catch (error) {
        console.log('ERROR --- ', error.response)
        throw error.response
      }
    },

  /**
   * Servicio para obtener la lista de permisos de un usuario segun el rol especificado
   * @param {*} data
   */
  async getAuthoritiesByRol ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/role/' + data.id + '/authorities',
        params: data,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener la lista de permisos de un usuario segun el rol especificado
   * @param {*} data
   */
  async getAuthoritiesByRolChecked ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/role/' + data.id + '/authorities/checked',
        params: data
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

   /**
   * Servicio para obtener la lista de permisos de un usuario para un servicio
   * @param {*} data
   */
    async getAuthoritiesByUser ({ commit, rootState }, data) {
      try {
        const response = await axios({
          method: 'GET',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          url: '/user/authorities',
          params: data
        })

        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return response.data
      } catch (error) {
        console.log('ERROR --- ', error.response)
        throw error.response
      }
    },

  /**
   * Servicio para cambiar roles y permisos del usuario seleccionado.
   * @param {*} data
   */
  async setRolesAndAuthorities ({
    commit, rootState
  }, data) {
    try {
      // Swagger valora null como espacio en blanco.
      if (data.query.projectId === null) {
        data.query.projectId = ' '
      }
      if (data.query.roles.length === 0) {
        data.query.roles = ['']
      }
      const response = await axios({
        method: 'PUT',
        url: '/user/' + data.userId + '/roleauthority',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query,
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false })
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para resetear contraseña de un usuario
   * @param {*} userId
   */
  async resetUserPassword ({
    commit, rootState
  }, userId) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/user/' + userId + '/password',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para eliminar un usuario
   * @param {*} userId
   */
  async deleteUser ({
    commit, rootState
  }, userId) {
    try {
      const response = await axios({
        method: 'DELETE',
        url: '/user/' + userId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Valida un usario para verificar si esxiste,si es asi nos devuelve el usuario
   * @param {*} username
   */
  async validateUser ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/user/validateusername',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          username: params.username,
          email: params.email
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
   * Valida ell cif de una empresa
   * @param {*} username
   */
  async validatePartyCif ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/user/validatepartytax',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          partyTax: params.partyTax
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Valida los datos de un usario
   */
  async validateUserDataNewUser ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/user/validateuserdata',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          username: params.username,
          name: params.name,
          firstSurname: params.firstSurname,
          secondSurname: params.secondSurname,
          nif: params.nif
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Método para crear o actualizar un usuario
  async saveUpdateUser ({
    commit, rootState
  }, data) {
    try {

      if (Array.isArray(data.userentities)) {
        data.userentities.forEach(entity => {
          if (entity.projectId === null || entity.projectId === "all") {
            entity.projectId = -1
          }
        });
      }

	  // --- Normalización en rolesAuthoritiesUser.projectId ---
	    if (data.rolesAuthoritiesUser && (data.rolesAuthoritiesUser.projectId === "all" || data.rolesAuthoritiesUser.projectId === null)) {
	      data.rolesAuthoritiesUser.projectId = -1
	    }

	    // --- Normalización en rolesAuthoritiesUser.roles[].idProject ---
	    if (data.rolesAuthoritiesUser && Array.isArray(data.rolesAuthoritiesUser.roles)) {
	      data.rolesAuthoritiesUser.roles.forEach(r => {
	        if (r && (r.idProject === "all" || r.idProject === null)) {
	          r.idProject = -1
	        }
	      })
	    }


      const response = await axios({
        method: 'POST',
        url: '/user',
        data: data,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      console.log('RESPONSE saveInvoice:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Método para validar las entidades de un nuevo usuario
  async validateEntitiesUser ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/user/validateuserentities',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: data
      })

      console.log('RESPONSE saveInvoice:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Datos Tabla Usuarios
  usersState: ({ commit }, payload) => {
    commit('USERS_STATE', payload)
  },
  queryUsersState: ({ commit }, payload) => {
    commit('QUERY_USERS_STATE', payload)
  },
  listSelectedFiltersUsersState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_USERS_STATE', payload)
  },
  // Nuevo usuario
  newUserSessionState: ({ commit }, payload) => {
    commit('NEW_USERS_STATE', payload)
  },
  modifyUserSessionState: ({ commit }, payload) => {
    commit('NEW_MODIFY_USERS_STATE', payload)
  },

  // Datos Select Filtros Usuarios
  optionsFilterUsersUsernameState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_USERS_USERNAME', payload)
  },
  optionsFilterUsersCompleteNameState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_USERS_COMPLETE_NAME', payload)
  },
  optionsFilterUsersCreationDateTimeState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_USERS_CREATION_DATE_TIME', payload)
  },
  optionsFilterUsersTrialState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_USERS_TRIAL', payload)
  },
  optionsFilterUsersEnableState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_USERS_ENABLE', payload)
  },
  optionsFilterUsersServiceAccountState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_USERS_SERVICE_ACCOUNT', payload)
  },
  optionsFilterUsersLastConnectionDateState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_USERS_LAST_CONNECTION_DATE', payload)
  },
  optionsFilterUsersIdNumberState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_USERS_ID_NUMBER', payload)
  },
  optionsFilterUsersPartyState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_USERS_PARTY', payload)
  },
  optionsFilterUsersPartyTypeState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_USERS_PARTY_TYPE', payload)
  },
  optionsFilterUsersIsPartySponsorState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_USERS_IS_PARTY_SPONSOR', payload)
  },
  optionsFilterUsersEmailState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_USERS_EMAIL', payload)
  },

  // Columnas Tabla Usuarios
  isShowUsuarioAction: ({ commit }, payload) => {
    commit('IS_SHOW_USUARIO', payload)
  },
  isShowCompleteNameAction: ({ commit }, payload) => {
    commit('IS_SHOW_COMPLETE_NAME', payload)
  },
  isShowFechaAltaAction: ({ commit }, payload) => {
    commit('IS_SHOW_FECHA_ALTA', payload)
  },
  isShowNumeroIntentosAction: ({ commit }, payload) => {
    commit('IS_SHOW_NUMERO_INTENTOS', payload)
  },
  isShowActivoAction: ({ commit }, payload) => {
    commit('IS_SHOW_ACTIVO', payload)
  },
  isShowEmailAction: ({ commit }, payload) => {
    commit('IS_SHOW_EMAIL', payload)
  },
  isShowFechaUltimaConexionAction: ({ commit }, payload) => {
    commit('IS_SHOW_FECHA_ULTIMA_CONEXION', payload)
  },
  isShowPasswordExpirationDateAction: ({ commit }, payload) => {
    commit('IS_SHOW_PASSWORD_EXPIRATION_DATE', payload)
  },
  isShowNumeroIdentificacionAction: ({ commit }, payload) => {
    commit('IS_SHOW_NUMERO_IDENTIFICACION', payload)
  },
  isShowServiceAccountAction: ({ commit }, payload) => {
    commit('IS_SHOW_SERVICE_ACCOUNT', payload)
  }
}

// mutations
const mutations = {
  resetSessionUsuarios (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  // Funcion para definir el filtro rápido de fechas cuando se es superadmin
  /*
  usersDatesSuperAdmin (state) {
    state.session.queryUsers.creationDateTimeFrom = initDateFrom(1)
  },
  */
  // Usuarios
  'USERS_STATE' (state, payload) {
    state.session.users = payload
  },
  'QUERY_USERS_STATE' (state, payload) {
    state.session.queryUsers = payload
  },
  'LIST_SELECTED_FILTERS_USERS_STATE' (state, payload) {
    state.session.listSelectedFiltersUsers = payload
  },

  // Nuevo usuario
  'NEW_USERS_STATE' (state, payload) {
    state.session.newUserSession = payload
  },
  'NEW_MODIFY_USERS_STATE' (state, payload) {
    state.session.modifyUserSession = payload
  },

  // Datos Select Filtros Usuarios
  'OPTIONS_FILTER_USERS_USERNAME' (state, payload) {
    state.session.optionsFilterUsersUsername = payload
  },
  'OPTIONS_FILTER_USERS_COMPLETE_NAME' (state, payload) {
    state.session.optionsFilterUsersCompleteName = payload
  },
  'OPTIONS_FILTER_USERS_CREATION_DATE_TIME' (state, payload) {
    state.session.optionsFilterUsersCreationDateTime = payload
  },
  'OPTIONS_FILTER_USERS_TRIAL' (state, payload) {
    state.session.optionsFilterUsersTrial = payload
  },
  'OPTIONS_FILTER_USERS_ENABLE' (state, payload) {
    state.session.optionsFilterUsersEnable = payload
  },
  'OPTIONS_FILTER_USERS_SERVICE_ACCOUNT' (state, payload) {
    state.session.optionsFilterUsersServiceAccount = payload
  },
  'OPTIONS_FILTER_USERS_LAST_CONNECTION_DATE' (state, payload) {
    state.session.optionsFilterUsersLastConnectionDate = payload
  },
  'OPTIONS_FILTER_USERS_ID_NUMBER' (state, payload) {
    state.session.optionsFilterUsersIdNumber = payload
  },
  'OPTIONS_FILTER_USERS_PARTY' (state, payload) {
    state.session.optionsFilterUsersParty = payload
  },
  'OPTIONS_FILTER_USERS_PARTY_TYPE' (state, payload) {
    state.session.optionsFilterUsersPartyType = payload
  },
  'OPTIONS_FILTER_USERS_IS_PARTY_SPONSOR' (state, payload) {
    state.session.optionsFilterUsersIsPartySponsor = payload
  },
  'OPTIONS_FILTER_USERS_EMAIL' (state, payload) {
    state.session.optionsFilterUsersEmail = payload
  },

  // Columnas Tabla Usuarios
  'IS_SHOW_USUARIO' (state, payload) {
    state.local.isShowUsuario = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.usuarios.isShowUsuario = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_COMPLETE_NAME' (state, payload) {
    state.local.isShowCompleteName = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.usuarios.isShowCompleteName = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_FECHA_ALTA' (state, payload) {
    state.local.isShowFechaAlta = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.usuarios.isShowFechaAlta = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NUMERO_INTENTOS' (state, payload) {
    state.local.isShowNumeroIntentos = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.usuarios.isShowNumeroIntentos = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ACTIVO' (state, payload) {
    state.local.isShowActivo = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.usuarios.isShowActivo = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_EMAIL' (state, payload) {
    state.local.isShowEmail = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.usuarios.isShowEmail = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_FECHA_ULTIMA_CONEXION' (state, payload) {
    state.local.isShowFechaUltimaConexion = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.usuarios.isShowFechaUltimaConexion = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_PASSWORD_EXPIRATION_DATE' (state, payload) {
    state.local.isShowPasswordExpirationDate = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.usuarios.isShowPasswordExpirationDate = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NUMERO_IDENTIFICACION' (state, payload) {
    state.local.isShowNumeroIdentificacion = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.usuarios.isShowNumeroIdentificacion = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SERVICE_ACCOUNT' (state, payload) {
    state.local.isShowServiceAccount = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.usuarios.isShowServiceAccount = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
